import { render, staticRenderFns } from "./NavLinks.vue?vue&type=template&id=06bc4836&"
import script from "./NavLinks.vue?vue&type=script&lang=js&"
export * from "./NavLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports